import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import MotionWrapper from '../../../components/MotionWrapper';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import FinDetailsView from './FinDetailsView';
import dayjs from 'dayjs';

const DetailView = ({ date, selected, batch, currency }) => {
  const { finDetailDashData, loading } = useSelector((state) => state.finance);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [col, setCol] = useState([]);

  useEffect(() => {
    if (finDetailDashData?.data?.length > 0) {
      const { id, totalForecast, totalCollected, cro, ...weekData } = finDetailDashData?.data[0];
      const weeks = [...new Set(Object.keys(weekData).map((key) => key.match(/week\d+/)?.[0]))];
      const columnss = weeks.flatMap((week) => [
        {
          field: `${week}Forecast`,
          headerName: 'Income Forecast',
          width: 150,
          renderHeader: (params) => (
            <Stack direction={'column'} spacing={1}>
              <Typography variant="body2">{params.colDef.headerName}</Typography>
              <Chip
                icon={<Icon icon="formkit:week" width="16" height="16" style={{ color: 'white' }} />}
                variant="contained"
                size="small"
                label={`Week ${week?.replace('week', '')}`}
                sx={{
                  background: 'linear-gradient(to right, #702dff, black, black)',
                  color: 'white',
                }}
              />
            </Stack>
          ),
        },
        {
          field: `${week}Collected`,
          headerName: 'Income Collected',
          width: 150,
          renderHeader: (params) => (
            <Stack direction={'column'} spacing={1}>
              <Typography variant="body2">{params.colDef.headerName}</Typography>
              <Chip
                icon={<Icon icon="formkit:week" width="16" height="16" style={{ color: 'white' }} />}
                variant="contained"
                size="small"
                label={`Week ${week?.replace('week', '')}`}
                sx={{
                  background: 'linear-gradient(to right,  #702dff, black, black)',
                  color: 'white',
                }}
              />
            </Stack>
          ),
        },
      ]);
      setCol(columnss);
    }
  }, [finDetailDashData]);

  const columns = [
    { field: 'croId', headerName: 'Cro Id', width: 80 },
    { field: 'croName', headerName: 'CRO', width: 200 },
    // ...col,
    {
      field: 'pendingAmount',
      headerName: 'Previous Month Fee',
      width: 180,
      renderCell: (params) => {
        const data = {
          croId: params.row.croId,
          fromDate: dayjs(date).format('YYYY-MM'),
          projectId: selected?.project_id,
          batchStatus: batch,
          currency: currency,
        };
        const queryString = new URLSearchParams(data).toString();
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              window.open(`/dashboard/detailed-fin-view?${queryString}&amountStatus=1`, '_blank');
            }}
          >
            {`${params.row.pendingAmount}`}
          </Button>
        );
      },
    },
    {
      field: 'amountToCollect',
      headerName: 'Collection For Current Month',
      width: 180,
      renderCell: (params) => {
        const data = {
          croId: params.row.croId,
          fromDate: dayjs(date).format('YYYY-MM'),
          projectId: selected?.project_id,
          batchStatus: batch,
          currency: currency,
        };
        const queryString = new URLSearchParams(data).toString();
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              window.open(`/dashboard/detailed-fin-view?${queryString}&amountStatus=2`, '_blank');
            }}
          >
            {`${params.row.amountToCollect || 0}`}
          </Button>
        );
      },
    },
    {
      field: 'amountCollected',
      headerName: 'Total Collected',
      width: 180,
      renderCell: (params) => {
        const data = {
          croId: params.row.croId,
          fromDate: dayjs(date).format('YYYY-MM'),
          projectId: selected?.project_id,
          batchStatus: batch,
          currency: currency,
        };
        const queryString = new URLSearchParams(data).toString();
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              window.open(`/dashboard/detailed-fin-view?${queryString}&amountStatus=3`, '_blank');
            }}
          >
            {`${params.row.amountCollected}`}
          </Button>
        );
      },
    },
    // {
    //   field: 'Details',
    //   headerName: 'Details',
    //   width: 180,
    //   renderCell: (params) => {
    //     const data = {
    //       croId: params.row.id,
    //       fromDate: dayjs(date).format('YYYY-MM'),
    //       projectId: selected?.project_id,
    //       batchStatus: batch,
    //       currency: currency,
    //     };
    //     return (
    //       <Box>
    //         <FinDetailsView data={data} />
    //       </Box>
    //     );
    //   },
    // },
    {
      field: 'Details',
      headerName: 'Details',
      width: 160,
      renderCell: (params) => {
        const data = {
          croId: params.row.croId,
          fromDate: dayjs(date).format('YYYY-MM'),
          projectId: selected?.project_id,
          batchStatus: batch,
          currency: currency,
        };

        const queryString = new URLSearchParams(data).toString();

        return (
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              window.open(`/dashboard/detailed-fin-view?${queryString}&amountStatus=0`, '_blank');
            }}
          >
            View Details
          </Button>
        );
      },
    },
  ];

  return (
    <Box>
      <MotionWrapper directions={'bottom'} delay={0.5}>
        <Paper elevation={3}>
          <Box sx={{ width: '100%', padding: 0 }}>
            <GlobalDatagrid
              tableHead={columns}
              rows={finDetailDashData?.data}
              rowUniqueId="croId"
              meta={finDetailDashData?.meta?.totalRecords || 0}
              headerHeight={90}
              rowClick={false}
              loading={loading}
            />
          </Box>
        </Paper>
      </MotionWrapper>
    </Box>
  );
};

export default DetailView;
